import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { graphqlRequest } from '../../utils/graphqlRequest';
import './styles/IncomeForm.css';

const CREATE_INCOME_MUTATION = `
  mutation CreateFinanceIncome($input: CreateFinanceIncomeInput!) {
    createFinanceIncome(input: $input) {
      id
      clientName
      amountReceived
      status
    }
  }
`;

const initialFormState = {
  projectId: '',
  clientName: '',
  invoiceNumber: '',
  source: '',
  amountReceived: '',
  paymentMode: '',
  receivedDate: '',
  status: '',
  remark: '',
};

const IncomeForm = ({ open, onClose, onSaved }) => {
  const [formData, setFormData] = useState(initialFormState);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (open) {
      setFormData(initialFormState);
    }
  }, [open]);

  if (!open) return null;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.clientName || !formData.amountReceived) {
      toast.error('Please fill in Client Name and Amount Received');
      return;
    }

    try {
      setSaving(true);
      await graphqlRequest(CREATE_INCOME_MUTATION, {
        input: {
          projectId: formData.projectId || undefined,
          clientName: formData.clientName,
          invoiceNumber: formData.invoiceNumber || undefined,
          source: formData.source || undefined,
          amountReceived: parseFloat(formData.amountReceived),
          paymentMode: formData.paymentMode || undefined,
          receivedDate: formData.receivedDate || undefined,
          status: formData.status || 'Pending',
          remark: formData.remark || undefined,
        },
      });

      setFormData(initialFormState);
      if (onSaved) onSaved();
      if (onClose) onClose();
    } catch (err) {
      console.error('Failed to create income:', err);
      toast.error('Failed to save income record. Please try again.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="income-form-overlay" role="dialog" aria-modal="true" onClick={onClose}>
      <div className="income-form-modal" onClick={(e) => e.stopPropagation()}>
        <div className="income-form-header">
          <h2>Add Income</h2>
          <button type="button" className="close-btn" onClick={onClose} aria-label="Close">
            &times;
          </button>
        </div>

        <form className="income-form" onSubmit={handleSubmit}>
          <div className="form-grid">
            <div className="form-field">
              <label>Project ID</label>
              <input
                name="projectId"
                value={formData.projectId}
                onChange={handleChange}
                placeholder="Enter Project Id"
              />
            </div>
            <div className="form-field">
              <label>Project Name/ Client Name</label>
              <input
                name="clientName"
                value={formData.clientName}
                onChange={handleChange}
                placeholder="Enter Project Id"
                required
              />
            </div>

            <div className="form-field">
              <label>Invoice Number</label>
              <input
                name="invoiceNumber"
                value={formData.invoiceNumber}
                onChange={handleChange}
                placeholder="Enter Project Id"
              />
            </div>
            <div className="form-field">
              <label>Source</label>
              <input
                name="source"
                value={formData.source}
                onChange={handleChange}
                placeholder="Enter Project Id"
              />
            </div>

            <div className="form-field">
              <label>Amount Receieved</label>
              <input
                name="amountReceived"
                type="number"
                step="0.01"
                value={formData.amountReceived}
                onChange={handleChange}
                placeholder="Enter Project Id"
                required
              />
            </div>
            <div className="form-field">
              <label>Payment Mode</label>
              <input
                name="paymentMode"
                value={formData.paymentMode}
                onChange={handleChange}
                placeholder="Enter Project Id"
              />
            </div>

            <div className="form-field">
              <label>Receieved Date</label>
              <input
                type="date"
                name="receivedDate"
                value={formData.receivedDate}
                onChange={handleChange}
              />
            </div>
            <div className="form-field">
              <label>Status</label>
              <input
                name="status"
                value={formData.status}
                onChange={handleChange}
                placeholder="Enter Project Id"
              />
            </div>
          </div>

          <div className="form-field remark-field">
            <label>Remark / Note</label>
            <textarea
              name="remark"
              rows={4}
              value={formData.remark}
              onChange={handleChange}
              placeholder="Message ......."
            />
          </div>

          <div className="form-actions">
            <button type="submit" className="save-btn" disabled={saving}>
              {saving ? 'Saving...' : 'Save'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default IncomeForm;
